import { AccessScopeKind, type AccessPersonInspectionQuery } from "@/graphql/generated/operations";

export type Inspection = AccessPersonInspectionQuery["accessPersonInspection"];
export function inspectionOrigins(person: Inspection, code: string) {
  return person.groups.flatMap(group => group.roles.filter(role => role.permissionCodes.includes(code)).map(role => ({ group, role })));
}
export function inspectionCodes(person: Inspection): string[] {
  return [...new Set(person.groups.flatMap(group => group.roles.flatMap(role => role.permissionCodes)))];
}
function scopes(person: Inspection, code: string): string[] {
  const values = inspectionOrigins(person, code).map(({ role }) => role.scope);
  if (values.some(scope => scope.kind === AccessScopeKind.Global)) return [AccessScopeKind.Global];
  return [...new Set(values.map(scope => `${scope.kind}:${scope.groupId ?? ""}`))].sort();
}
export function comparePermission(first: Inspection, second: Inspection, code: string) {
  const left = scopes(first, code), right = scopes(second, code);
  if (!left.length) return "onlySecond";
  if (!right.length) return "onlyFirst";
  if (left.join("|") !== right.join("|")) return "scopeDifference";
  // Equal relative scope kinds do not imply equal target people for two different actors.
  if (left.some(scope => scope.startsWith(AccessScopeKind.ManagedPeople))) return "personRelative";
  const origins = (person: Inspection) => [...new Set(inspectionOrigins(person, code)
    .map(({ group, role }) => `${group.id}:${role.roleId}`))].sort().join("|");
  return origins(first) === origins(second) ? "same" : "originDifference";
}
